import {RoleAuthCustomerDto} from "./role-auth-customer.dto";
import {CustomerTypeDto} from "./customer-type.dto";
import {DtoDetail} from "../../../../../core/shared/dto/dto.detail";

export class RoleAuthCustomerTypeDto extends DtoDetail{


    public roleAuthCustomerDto? : RoleAuthCustomerDto;
    public roleAuthCustomerDtoId : number;
    public roleAuthCustomerDtoName : string;
    public customerTypeDto? : CustomerTypeDto;
    public customerTypeDtoId : number;
    public customerTypeDtoName : string;

}